export const SUPPLIER_REQUIREMENT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  BOOL: 'yes_no',
  DATE: 'date',
  FILE: 'file',
  LIST: 'list',
}

export function getIconByType(type) {
  switch (type) {
    case SUPPLIER_REQUIREMENT_TYPE.TEXT:
      return 'custom:text1Icon'
    case SUPPLIER_REQUIREMENT_TYPE.NUMBER:
      return 'custom:twoInCircleIcon'
    case SUPPLIER_REQUIREMENT_TYPE.BOOL:
      return 'custom:boolIcon'
    case SUPPLIER_REQUIREMENT_TYPE.DATE:
      return 'custom:emptyCalendarIcon'
    case SUPPLIER_REQUIREMENT_TYPE.FILE:
      return 'custom:cloudUpIcon'
    case SUPPLIER_REQUIREMENT_TYPE.LIST:
      return 'custom:listIcon'
    default:
      return ''
  }
}